import { useCalendar } from "./useCalendar";
import { useHookSubscribe } from "../../../hooks/hookSubscribe";

export function useCalendarOpenState(): [boolean, () => void] {
  const context = useCalendar();
  const value = useHookSubscribe(context.currentOpenState, context.openState);
  const toggleContextValue = () => {
    context.setOpenState(!value);
  }
  return [value, toggleContextValue];
}
